import { render, staticRenderFns } from "./smallOomADT.vue?vue&type=template&id=760a8fd6&scoped=true"
import script from "./smallOomADT.vue?vue&type=script&lang=js"
export * from "./smallOomADT.vue?vue&type=script&lang=js"
import style0 from "./smallOomADT.vue?vue&type=style&index=0&id=760a8fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760a8fd6",
  null
  
)

export default component.exports